import { ESalesType, ISalesLink } from '../../types/offersData';

export function getLabel(link: ISalesLink): string | undefined {
  return link.salesType === ESalesType.ConsultantPage ? 'Бесплатно' : undefined;
}
